<template>
  <div class="dropdownElement d-flex align-items-center justify-content-center">
    <span>{{ $t('powersupplyGui.bmsController.guaranteedOutputCurrent') }}</span>
    <input type="number" class="daliPowerInput" @change="isChanged" @keyup="isChanged" v-model="editCustom.daliPower"/>
    <span>mA</span>
  </div>

  <!--     <div @click="selectCard" class="p-0 p-sm-1 col-12 col-md-6 col-lg-4 col-xl-3 mb-2">
          <div class="card h-100"  :class="getBGColor">
              <div class="card-header">
                  {{$t('powersupplyGui.bmsController.header')}}
              </div>
              <div class="card-body">
                  <label for="basic-url" class="form-label">{{$t('powersupplyGui.bmsController.guaranteedOutputCurrent')}}</label>
                  <div class="input-group mb-3">
                      <input @keyup="isChanged" type="number" min="1" max="250" v-model="editCustom.daliPower" class="form-control" placeholder="" />
                      <span  class="input-group-text">mA</span>
                  </div>
                 <button class="btn btn-outline-primary btn-small"><i class="fa-solid fa-magnifying-glass"></i> {{$t('Find_in_DALI_Alliance_Database')}}</button>
             </div>
          </div>
      </div> -->
</template>

<script>

export default {
  name: "ApplicationControllerCardCustom",
  emits: ['onChange', 'selectCard'],
  data() {
    return {
      editCustom: this.controller
    }
  },
  created() {
    this.$emit('selectCard', this.editCustom);
  },
  methods: {
    selectCard() {
      this.$emit('selectCard', this.editCustom);
    },
    isChanged() {
      if (this.editCustom.daliPower < 1) {
        this.editCustom.daliPower = 1;
      }
      if (this.editCustom.daliPower > 250) {
        this.editCustom.daliPower = 250
      }
      this.$emit('onChange')
    }
  },
  computed: {
    getBGColor() {
      if (this.controller.active) {
        return "active"
      }
      return ""
    }
  },
  props: {
    controller: Object
  }
}
</script>

<style lang="scss" scoped>
.dropdownElement {
  position: relative;
  padding-block: 0.5rem;
  border-radius: var(--border-radius-default);
  background-color: var(--color-white);
  z-index: 10;
  text-align: center;
  border: none;
}

.daliPowerInput {
  width: 100px;
  margin-top: 3px;
}
</style>